import { z } from 'zod';
import {
  CustomPromptPostProcessingTypeSchema,
  LLMPenaltySchema,
  LLMMaxTokensSchema,
  LLMMinPSchema,
  LLMRepetitionPenaltySchema,
  LLMTemperatureSchema,
  LLMTopASchema,
  LLMTopKSchema,
  LLMTopPSchema,
  RegexRuleSchema,
  STPromptNodeSchema,
  STPromptOrderBlockSchema,
  STPresetTemplateKindSchema,
} from './base';
import {
  createCompatibilitySTPresetDefaults,
  createGardenSTPresetDefaults,
  DEFAULT_GARDEN_ST_PROMPT_ORDER,
  DEFAULT_GARDEN_ST_PROMPTS,
} from './defaults';

export const STPresetSchema = z.object({
  enabled: z.boolean().default(true),
  prompts: z.array(STPromptNodeSchema).default(DEFAULT_GARDEN_ST_PROMPTS),
  prompt_order: z.array(STPromptOrderBlockSchema).default(DEFAULT_GARDEN_ST_PROMPT_ORDER),
  use_sysprompt: z.boolean().default(false),
  custom_prompt_post_processing: CustomPromptPostProcessingTypeSchema.default(''),
  temperature: LLMTemperatureSchema,
  topP: LLMTopPSchema,
  topK: LLMTopKSchema,
  topA: LLMTopASchema,
  minP: LLMMinPSchema,
  repetitionPenalty: LLMRepetitionPenaltySchema,
  maxTokens: LLMMaxTokensSchema,
  presencePenalty: LLMPenaltySchema,
  frequencyPenalty: LLMPenaltySchema,
});
export type STPreset = z.infer<typeof STPresetSchema>;

export const STPresetConfigSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1).default('兼容预设配置'),
  presetKind: STPresetTemplateKindSchema.default('compatibility'),
  preset: STPresetSchema.default(createCompatibilitySTPresetDefaults()),
  regex_rules: z.array(RegexRuleSchema).default([]),
});
export type STPresetConfig = z.infer<typeof STPresetConfigSchema>;

export function createGardenBuiltinSTPreset(): STPreset {
  return STPresetSchema.parse(createGardenSTPresetDefaults());
}

export function createCompatibilitySTPreset(): STPreset {
  return STPresetSchema.parse(createCompatibilitySTPresetDefaults());
}
